import React from 'react';
const FooterCopyright = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "xs:flex xs:flex-row xss:flex-column text-xs" },
            React.createElement("p", { className: "inline" }, "\u00A9\u00A0BITE\u00A0GmbH\u00A02022\u00A0|\u00A0"),
            React.createElement("p", { className: "inline" }, "Einige\u00A0Rechte\u00A0vorbehalten"))));
};
export default FooterCopyright;
